import { render, staticRenderFns } from "./CollapseTable.vue?vue&type=template&id=3273e46f&scoped=true&"
import script from "./CollapseTable.vue?vue&type=script&lang=js&"
export * from "./CollapseTable.vue?vue&type=script&lang=js&"
import style0 from "./CollapseTable.vue?vue&type=style&index=0&id=3273e46f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3273e46f",
  null
  
)

export default component.exports